/**
 * Liest den Routenparameter `viewId` als Zahl — Pendant zur Routenbeschränkung
 * `@page "/container/{viewId:int}"`, die nur ganzzahlige Werte durchlässt.
 */

import { useParams } from 'react-router-dom';

export function useViewIdParam(): number {
  const { viewId } = useParams();
  const parsed = Number(viewId);
  return Number.isInteger(parsed) ? parsed : 0;
}

export default useViewIdParam;
